import React, { useState } from "react";
import ClientList from "./ClientList";
import UserList from "./UserList";
import FleetList from "./FleetList";
import RequestForFirmList from "./RequestForFirmList";
import BunkerPrices from "./BunkerPrices";
import Ports from "./Ports";
import { useBootstrap } from "./BootstrapProvider";
import { config } from "../config";
import "./AccountManager.css";

const AccountManager: React.FC = () => {
  const { isBootstrapped, error } = useBootstrap();
  const [selectedClientDomain, setSelectedClientDomain] = useState<
    string | null
  >(null);
  const { apiBaseUrl } = config;
  const [activeSection, setActiveSection] = useState<
    "clients" | "bunkers" | "ports"
  >("clients");

  if (error) {
    return (
      <div className="am-container">
        <div className="am-error">{error}</div>
      </div>
    );
  }

  if (!isBootstrapped) {
    return null;
  }

  return (
    <div className="admin-container">
      <h2 className="am-title">Account Manager</h2>

      {/* Section Toggle Buttons */}
      <div className="am-section-buttons">
        <button
          className={`primary-button ${activeSection === "clients" ? "active" : ""}`}
          onClick={() => setActiveSection("clients")}
        >
          Clients
        </button>
        <button
          className={`primary-button ${activeSection === "bunkers" ? "active" : ""}`}
          onClick={() => setActiveSection("bunkers")}
        >
          Bunker Prices
        </button>
        <button
          className={`primary-button ${activeSection === "ports" ? "active" : ""}`}
          onClick={() => setActiveSection("ports")}
          style={{ marginLeft: 8 }}
        >
          Port Notes
        </button>
      </div>

      {/* Clients Section */}
      {activeSection === "clients" && (
        <>
          <ClientList
            apiUrl={apiBaseUrl}
            selectedClientDomain={selectedClientDomain}
            setSelectedClientDomain={setSelectedClientDomain}
            enableAddClient={false}
          />

          {selectedClientDomain && (
            <>
              <UserList
                clientDomain={selectedClientDomain}
                enableAddUser={false}
              />
              <FleetList clientDomain={selectedClientDomain} />
              <RequestForFirmList
                apiUrl={apiBaseUrl}
                clientDomain={selectedClientDomain}
              />
            </>
          )}
        </>
      )}

      {/* Bunkers Section */}
      {activeSection === "bunkers" && (
        <div style={{ marginTop: 40 }}>
          <BunkerPrices />
        </div>
      )}

      {/* Ports Section */}
      {activeSection === "ports" && (
        <div style={{ marginTop: 40 }}>
          <Ports />
        </div>
      )}
    </div>
  );
};

export default AccountManager;
